import { createFileRoute } from '@tanstack/react-router'
import StatePage from '@/components/StatePage'
import { getReportYear, getStateRow, slugToCode } from '@/lib/ic3'
import { usePageSeo } from '@/lib/page-seo'

export const Route = createFileRoute('/states/$slug/')({
  component: StateRoute,
})

function StateRoute() {
  const { slug } = Route.useParams()
  const code = slugToCode(slug) ?? ''
  const name = getStateRow(code)?.name ?? code
  usePageSeo({
    title: `${name} Scam Statistics & Top Scams · ScamDefense`,
    description: `Reported scam losses in ${name} (FBI IC3 ${getReportYear()}), the fraud types hitting ${name} residents hardest, and how to recognize them before money moves.`,
    canonicalPath: `/states/${slug}`,
  })
  return <StatePage code={code} />
}
